export const host = {
  DEV: "d-dental-portfolio-static.dev.digitaledge.cigna.com",
  QA: "t-dental-portfolio-static.test.digitaledge.cigna.com",
  PROD: "p-dental-portfolio-static.digitaledge.cigna.com",
  LOCAL: "localhost:3000",
  DEV_PROVIDERS_DOT_BRIGHTER_COM: "dev.providers.brighter.com",
  QA_PROVIDERS_DOT_BRIGHTER_COM: "test.providers.brighter.com",
  PROD_LIVE:"providers.brighter.com"
};

export const getbaseURL = () => {
  const devUrl =
    "https://d-practice-media.dev.digitaledge.cigna.com/pbc/dental-app/";
  const qaUrl =
    "https://a-practice-media.test.digitaledge.cigna.com/pbc/dental-app/";
  const prodUrl =
    "https://p-practice-media.digitaledge.cigna.com/pbc/dental-app/";
  switch (window.location.host) {
    case host.DEV_PROVIDERS_DOT_BRIGHTER_COM:
    case host.DEV:
      return devUrl;
    case host.LOCAL:
      return devUrl;
      
    case host.QA_PROVIDERS_DOT_BRIGHTER_COM:
    case host.QA:
      return qaUrl;

    case host.PROD:
      return prodUrl;

    case host.PROD_LIVE:
      return prodUrl;
  }
};

export const baseUrl = getbaseURL();
